/* eslint-disable prettier/prettier */
// ES6

import focus from "@alpinejs/focus";
import { initComponents, loadAlpine } from "../utils/loaders/alpineLoader.js";

import { initAnimation } from "./animatePage.js";

const init = () => {
  const myPromise = new Promise((resolve, reject) => {
    loadAlpine().then(() => {
      /**
       * Load all components
       */
      initComponents([
        "alpine-third-party",
        "alpine-lazy",
        "alpine-accordion",
        "alpine-open-close",
        "alpine-accordion-carousel",
        "alpine-tab-accordion",
        "alpine-tab",
        "alpine-carousel",
        "alpine-header",
        "alpine-formvalidation",
        "alpine-readmore",
        "alpine-datatable",
        "alpine-loadmore-filter",
        "alpine-social-share",
        "alpine-tab-with-animation",
        "alpine-modal",
        "alpine-custom-form",
        "alpine-industry-snapshot-tab",
        "alpine-site-tab",
        "alpine-change-iframe-form",
        "alpine-back-to-top",
        "alpine-table",
        "alpine-iframe-anchor",
        "alpine-career-pathways"
      ]).then(() => {
        window.Alpine.plugin(focus);
        window.Alpine.start();
        console.log("Alpine has loaded ");
        initAnimation();
        resolve();
      });
    });
  });

  return myPromise;
};

export { init };
